import { Flex } from "@fluentui/react-northstar";
import styled from "styled-components";

export const FeatureCard = styled(Flex)`
    padding: 24px 16px;
    gap: 40px;
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.07) 0px 0.3px 0.9px,
        rgba(0, 0, 0, 0.11) 0px 1.6px 3.6px;
    border-radius: 8px;
    cursor: pointer;

    :hover {
        transition: background-color 0.2s;
        background: #f5f5f5;
    }
`;

export const IconWrapper = styled.div`
    background: ${(props) => props.bgColor};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    .ui-icon {
        font-size: 24px;
        color: white;
    }
`;
